module.exports = __webpack_public_path__ + "img/shared-folder-icon.0530b615.svg";